export const PORTFOLIO_ADMIN_CONSTANTS = Object.freeze({
    PROFILE_GET: 'PORTFOLIO_ADMIN__PROFILE_GET',
    PROFILE_SAVE: 'PORTFOLIO_ADMIN__PROFILE_SAVE',
    ABOUT_GET: 'PORTFOLIO_ADMIN__ABOUT_GET',
    ABOUT_SAVE: 'PORTFOLIO_ADMIN__ABOUT_SAVE',
    STATS_LIST: 'PORTFOLIO_ADMIN__STATS_LIST',
    STATS_SAVE: 'PORTFOLIO_ADMIN__STATS_SAVE',
    STATS_REMOVE: 'PORTFOLIO_ADMIN__STATS_REMOVE',
    SKILLS_LIST: 'PORTFOLIO_ADMIN__SKILLS_LIST',
    SKILLS_SAVE: 'PORTFOLIO_ADMIN__SKILLS_SAVE',
    SKILLS_REMOVE: 'PORTFOLIO_ADMIN__SKILLS_REMOVE',
    PROJECTS_LIST: 'PORTFOLIO_ADMIN__PROJECTS_LIST',
    PROJECTS_SAVE: 'PORTFOLIO_ADMIN__PROJECTS_SAVE',
    PROJECTS_REMOVE: 'PORTFOLIO_ADMIN__PROJECTS_REMOVE',
    EXPERIENCE_LIST: 'PORTFOLIO_ADMIN__EXPERIENCE_LIST',
    EXPERIENCE_SAVE: 'PORTFOLIO_ADMIN__EXPERIENCE_SAVE',
    EXPERIENCE_REMOVE: 'PORTFOLIO_ADMIN__EXPERIENCE_REMOVE',
    BLOG_LIST: 'PORTFOLIO_ADMIN__BLOG_LIST',
    BLOG_SAVE: 'PORTFOLIO_ADMIN__BLOG_SAVE',
    BLOG_REMOVE: 'PORTFOLIO_ADMIN__BLOG_REMOVE',
    SOCIALS_LIST: 'PORTFOLIO_ADMIN__SOCIALS_LIST',
    SOCIALS_SAVE: 'PORTFOLIO_ADMIN__SOCIALS_SAVE',
    SOCIALS_REMOVE: 'PORTFOLIO_ADMIN__SOCIALS_REMOVE',
});

const C = PORTFOLIO_ADMIN_CONSTANTS;
export const PORTFOLIO_ADMIN_ENDPOINTS = Object.freeze({
    [C.PROFILE_GET]: '/portfolio/profile',
    [C.PROFILE_SAVE]: '/portfolio/profile/save',
    [C.ABOUT_GET]: '/portfolio/about',
    [C.ABOUT_SAVE]: '/portfolio/about/save',
    [C.STATS_LIST]: '/portfolio/stats',
    [C.STATS_SAVE]: '/portfolio/stats/save',
    [C.STATS_REMOVE]: '/portfolio/stats/remove',
    [C.SKILLS_LIST]: '/portfolio/skills',
    [C.SKILLS_SAVE]: '/portfolio/skills/save',
    [C.SKILLS_REMOVE]: '/portfolio/skills/remove',
    [C.PROJECTS_LIST]: '/portfolio/projects',
    [C.PROJECTS_SAVE]: '/portfolio/projects/save',
    [C.PROJECTS_REMOVE]: '/portfolio/projects/remove',
    [C.EXPERIENCE_LIST]: '/portfolio/experience',
    [C.EXPERIENCE_SAVE]: '/portfolio/experience/save',
    [C.EXPERIENCE_REMOVE]: '/portfolio/experience/remove',
    [C.BLOG_LIST]: '/portfolio/blog',
    [C.BLOG_SAVE]: '/portfolio/blog/save',
    [C.BLOG_REMOVE]: '/portfolio/blog/remove',
    [C.SOCIALS_LIST]: '/portfolio/socials',
    [C.SOCIALS_SAVE]: '/portfolio/socials/save',
    [C.SOCIALS_REMOVE]: '/portfolio/socials/remove',
});
